import React from "react";
import Favorite from "../../components/Favorite/Favorite";
// import style from "Favorite.module.css";

export default function FavoriteView() {
  return <div>
    <Favorite />
  </div>;
}
